import { useEffect, useState } from "react";

import ImageWidgetContent from "./ImageWidgetContent";
import EmbedWidgetContent from "./EmbedWidgetContent";
import VideoWidgetContent from "./VideoWidgetContent";
import TriggerWidgetContent from "./TriggerWidgetContent";
import CommentWidgetContent from "./CommentWidgetContent";
import QuestionWidgetContent from "./QuestionWidgetContent";
import DownloadFileWidgetContent from "./DownloadFileWidgetContent";
import MultipleChoiceQuestionWidgetContent from "./MultipleChoiceQuestionWidgetContent";
import FillInTheBlankWidgetContent from "./FillInTheBlankWidgetContent";

import { AddWidget } from "../AddWidget";

import {
  imageWidget,
  embedWidget,
  videoWidget,
  triggerWidget,
  commentWidget,
  questionWidget,
  downloadFileWidget,
  multipleChoiceQuestionWidget,
  fillInTheBlankWidget
} from "../../../constants/widget";

function WidgetContent(props) {
  const [closed, setClosed] = useState(false);
  useEffect(() => {
    setClosed(props.collapseAll);
  }, [props.collapseAll])

  function onSetWidgets(prop, value) {
    const { widgets, position } = props;
    const idx = position - 1;
    let widget = { ...widgets[idx] }
    widget[prop] = value;

    let arr = widgets;
    arr[idx] = widget;
    props.setWidgets(arr);
  }

  function renderWidgetContent() {
    const _props = {
      ...props,
      onSetWidgets: onSetWidgets
    }

    switch (props.lesson_module_name) {
      case imageWidget:
        return <ImageWidgetContent {..._props} />
      case embedWidget:
        return <EmbedWidgetContent {..._props} />
      case videoWidget:
        return <VideoWidgetContent {..._props} />
      case triggerWidget:
        return <TriggerWidgetContent {..._props} />
      case commentWidget:
        return <CommentWidgetContent {..._props} />
      case questionWidget:
        return <QuestionWidgetContent {..._props} />
      case downloadFileWidget:
        return <DownloadFileWidgetContent {..._props} />
      case multipleChoiceQuestionWidget:
        return <MultipleChoiceQuestionWidgetContent {..._props} />
      case fillInTheBlankWidget:
        return <FillInTheBlankWidgetContent {..._props} />
      default:
        return <CommentWidgetContent {..._props} />;
    }
  }

  return (
    <div style={{ position: "relative" }}>
      <div className={closed ? "WidgetContent WidgetContent--closed" : "WidgetContent"}>
        {!closed && renderWidgetContent()}
      </div>
      <AddWidget {...props} />
    </div>
  )
}

export { WidgetContent };